import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import './registerServiceWorker'
import ymapPlugin from "vue-yandex-maps";

Vue.use(Vuetify)
Vue.use(VueGoodTablePlugin)
Vue.use(ymapPlugin);

new Vue({
  vuetify : new Vuetify(),
  render: h => h(App),
}).$mount('#app')
